import { sortBy } from 'lodash'

const sortByName = (items = []) => sortBy(items, 'name')

export default sortByName